
























































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import CreateProductIssueRequest from '@/models/Products/ProductIssues/CreateProductIssueRequest';

@Component({ name: 'ProductIssueCreateDialog' })
export default class extends SaascadaVueDialog {

    request: CreateProductIssueRequest = new CreateProductIssueRequest();
    nextIssueNumber: number = 0;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            // If there is an issue number then calculate the next issue number as current issue number + 1, and
            // if not then default it to 1 - this should be correct even if the previous issue is was rejected or cancelled
            this.nextIssueNumber = ProductDetailsModule.product.currentIssueNumber ? ProductDetailsModule.product.currentIssueNumber + 1 : 1;
            // Create the request
            this.request = new CreateProductIssueRequest();
            this.request.productId = ProductDetailsModule.product.id;
            this.request.name = ProductDetailsModule.product.generalSettings.name + " Issue " + this.nextIssueNumber;
            this.request.code = ProductDetailsModule.product.generalSettings.code + "_" + this.nextIssueNumber;
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.createProductIssue(this.request);
            await ProductDetailsModule.getProductIssues(1);
        }
    }

}
